'use client';

import { useSyncExternalStore } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders children into a portal div (#__print-portal) at the body level.
 * Global print CSS hides everything except `body > #__print-portal`,
 * so content placed here becomes the sole printed output.
 */

function getPortalContainer() {
  let el = document.getElementById('__print-portal');
  if (!el) {
    el = document.createElement('div');
    el.id = '__print-portal';
    document.body.appendChild(el);
  }
  return el;
}

const subscribe = () => () => {};

export function PrintPortal({ children }: { children: React.ReactNode }) {
  const container = useSyncExternalStore(
    subscribe,
    getPortalContainer,
    () => null
  );

  if (!container) return null;
  return createPortal(children, container);
}
